module.exports = __webpack_public_path__ + "static/media/art_board.a8360ae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameShipPainting/art_board.png
// module id = 2470
// module chunks = 0